import { Box, TextField, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";

const ContactForm = () => {
  return (
    <Box
      component={motion.div}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      sx={{
        backgroundColor: "#e9b400",
        color: "#fff",
        p: { xs: 3, md: 5 },
        height: "100%",
      }}
    >
      <Typography
        variant="h1"
        fontWeight={700}
        mt={3}
        mb={5}
        sx={{
          color: "#312929",
          fontSize: { xs: 30, md: 40 },
          position: "relative",
          display: "inline-block",
        }}
      >
        Get in touch
        <Box className="headingAfter"></Box>
      </Typography>

      <TextField fullWidth label="Name" variant="standard" sx={{ mb: 3 }} />
      <TextField fullWidth label="E-Mail" variant="standard" sx={{ mb: 3 }} />
      <TextField
        fullWidth
        label="Phone Number"
        variant="standard"
        sx={{ mb: 3 }}
      />

      <TextField
        fullWidth
        label="Your Message"
        variant="standard"
        multiline
        rows={4}
        sx={{ mb: 4 }}
      />
      <Box sx={{ mt: 3 }}>
        <button class="btn-default" role="button">
          Submit Now
        </button>
      </Box>
    </Box>
  );
};

export default ContactForm;
